
/// <amd-module name="Release/Helpers/BrowserStorage" />
/**
* 
* @param storageKey Identifier in the local storage
* @param strContent String content to be stored
*/
export function saveContentToLocalStorage(storageKey: string, strContent: string): void {
    if (!storageKey) {
        throw new Error("BrowserStorage.saveContentToLocalStorage : storageKey is null or empty");
    }

    window.localStorage.setItem(storageKey, strContent);
}

/**
 * 
 * @param storageKey Identifier in the local storage
 */
export function getContentFromLocalStorage(storageKey: string): string | null {
    const content = window.localStorage.getItem(storageKey);
    return content;
}

